export default "__VITE_ASSET__BnGH_hGq__";